import routes from 'app_search/routes'

/*
  TODO: Until we have a true SPA and a higher-level React Router, we need to hack the
  url to include the hash (#). Using React Router's Link component cannot navigate to a sibling-level
  React Router in another app, and the Rails app is still using separate React apps for
  all components at present.
*/
export const getDocumentUrl = (engineName, documentId) => `${routes.locoMocoEngineDocumentsPath(engineName)}#/${encodeURIComponent(documentId)}`
